import React, { useState } from "react";
import { useAtom } from "jotai";
import {
    Table,
    TableBody,
    TableContainer,
    Backdrop,
    CircularProgress
} from "@mui/material";
import { BookingsTableHead } from "./BookingTableHead";
import { BookingRow } from "./BookingRow";
import {
    isLoadingBookingsAtom,
    isLoadingPendingBookingsAtom
} from "../../atoms/atoms";

export const BookingsTable = ({ bookings = [] }) => {
    const [selectedRows, setSelectedRows] = useState([]);
    const [isLoadingBookings] = useAtom(isLoadingBookingsAtom);
    const [isLoadingPendingBookings] = useAtom(isLoadingPendingBookingsAtom);

    return (
        <TableContainer sx={{ tableLayout: "fixed", width: "100%" }}>
            <Backdrop
                open={isLoadingBookings || isLoadingPendingBookings}
                sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
            >
                <CircularProgress color="primary" />
            </Backdrop>
            <Table>
                <BookingsTableHead />
                <TableBody>
                    {bookings.map((booking) => (
                        <BookingRow
                            key={booking.id}
                            bookingData={booking}
                            id={booking.id}
                            handleSelect={setSelectedRows}
                            selected={selectedRows}
                        />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
